// @flow
import { FormattedMessage } from 'react-intl';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback';
import React from 'react';
import styles from './Trust.module.scss';

type Props = {};

const Trust = () => {
    return (
        <div className={styles.trust}>
            <div className={styles.centered}>
                <div className={styles.images}>
                    <div className={styles['column-title']}>
                        <FormattedMessage id="as_seen_on" />
                    </div>
                    <div className={styles['column-content']}>
                        <div className={styles.nbc}>
                            <ImageWithFallback
                                style={{ maxHeight: '43px', maxWidth: '44px' }}
                                src="https://p1.liveauctioneers.com/dist/images/NBC.svg"
                                alt="NBC"
                            />
                        </div>
                        <div className={styles.abc}>
                            <ImageWithFallback
                                style={{ maxHeight: '38px', maxWidth: '38px' }}
                                src="https://p1.liveauctioneers.com/dist/images/ABC.svg"
                                alt="ABC"
                            />
                        </div>
                        <div className={styles.today}>
                            <ImageWithFallback
                                style={{ maxHeight: '42px', maxWidth: '57px' }}
                                src="https://p1.liveauctioneers.com/dist/images/TODAY.svg"
                                alt="Today"
                            />
                        </div>
                        <div className={styles['chicago-tribune']}>
                            <ImageWithFallback
                                style={{ maxHeight: '20px', maxWidth: '137px' }}
                                src="https://p1.liveauctioneers.com/dist/images/ChicagoTribune.svg"
                                alt="Chicago Tribune"
                            />
                        </div>
                        <div className={styles['architectural-digest']}>
                            <ImageWithFallback
                                style={{ maxHeight: '14px', maxWidth: '162px' }}
                                src="https://p1.liveauctioneers.com/dist/images/ArchDigest.svg"
                                alt="Architectural Digest"
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.separator} />
                <div className={styles.shop}>
                    <div className={styles['column-title']}>
                        <FormattedMessage id="shop_with_confidence" />
                    </div>
                    <div className={styles['column-content']}>
                        <div className={styles['column-content-left']}>
                            <FormattedMessage id="since_2002_liveauctioneers_has_made_items" />
                        </div>
                        <div className={styles['column-content-right']}>
                            <a
                                href="http://www.bbb.org/new-york-city/business-reviews/internet-auction-service/live-auctioneers-llc-in-new-york-ny-123530/#bbbonlineclick"
                                target="_blank"
                                rel="nofollow noopener"
                            >
                                <ImageWithFallback
                                    src="https://p1.liveauctioneers.com/seals/blue-seal-250-52-bbb-123530.png"
                                    alt="LiveAuctioneers LLC BBB Business Review"
                                    style={{ height: '52px', width: '250px' }}
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo<Props>(Trust);
